
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as RssPage05x5BrOD0mt1wY6znGLkNifPTT0Pz0V3P6Eb4dPeLZQMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/RssPage.vue?macro=true";
import { default as Homepage_45A1tyYtp_8nqtUie9FFz56CwfLNREyjQ_Q1mb46UYJkMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/Homepage.vue?macro=true";
import { default as PostsPagem_45jMKG45aZNO6IfcDUztDoq5cwb6JnO49GmoGh7j4tAMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/PostsPage.vue?macro=true";
import { default as CustomPage9rfEjCO7so_U9hPSugdGTEzHjQ5zziNTtjA_458nbOcXwMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/CustomPage.vue?macro=true";
import { default as SearchPagelYxe66h5fRjBa9gLIInAFRMnYQ6tlTxCgxWHgV0S0SkMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/SearchPage.vue?macro=true";
import { default as SitemapPageE_45XHW7M_45hN3ata7ojF5ACYoGZ3FI6y_d0GhihmXH9yoMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/SitemapPage.vue?macro=true";
import { default as NotFoundPageM36vvCh2fOyGuR1ACoZ4gC409Xguvthbg5mSDkEG_DcMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/NotFoundPage.vue?macro=true";
import { default as DashboardPageW8ME7kvlz5faPoIPQCy4RsnKzqgizs_sOzCD2lSscgoMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/DashboardPage.vue?macro=true";
import { default as SinglePostPage6VqlIha0NTDxfyr778UCV72yugGRXdRAUgeIJlmDaG4Meta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/SinglePostPage.vue?macro=true";
import { default as EventCalendarPage9pKq0oyt64Bat3HItENdu8ChCGJfadSP9UbFVcbUn0gMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/EventCalendarPage.vue?macro=true";
import { default as MenuCollectionPageEFpRx4tCe6nzioGlhLCl08SCikIBS_bL2EFsKYjWIewMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/MenuCollectionPage.vue?macro=true";
export default [
  {
    name: "RssPage",
    path: "/RssPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/RssPage.vue")
  },
  {
    name: "Homepage",
    path: "/Homepage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/Homepage.vue")
  },
  {
    name: "PostsPage",
    path: "/PostsPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/PostsPage.vue")
  },
  {
    name: "CustomPage",
    path: "/CustomPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/CustomPage.vue")
  },
  {
    name: "SearchPage",
    path: "/SearchPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/SearchPage.vue")
  },
  {
    name: "SitemapPage",
    path: "/SitemapPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/SitemapPage.vue")
  },
  {
    name: "NotFoundPage",
    path: "/NotFoundPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/NotFoundPage.vue")
  },
  {
    name: "DashboardPage",
    path: "/DashboardPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/DashboardPage.vue")
  },
  {
    name: "SinglePostPage",
    path: "/SinglePostPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/SinglePostPage.vue")
  },
  {
    name: "EventCalendarPage",
    path: "/EventCalendarPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/EventCalendarPage.vue")
  },
  {
    name: "MenuCollectionPage",
    path: "/MenuCollectionPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/MenuCollectionPage.vue")
  }
]